export default "__VITE_ASSET__2f996755__"